import { SoundController } from "@lib/titan2-slingo/dist/game/controller/SoundController";
import { GameHungryHenrySoundEvents } from "../event/GameSountEvent";
import { MainTransitionEvents } from "../../view/abstract/display/GameMainTransition";
import { FeaturePurpleFishEvents } from "../../view/abstract/display/features/purplefish/FeaturePurpleFish";
import { SeededRandom } from "../../utils/SeededRandom";
export class GameSoundHungryHenryController extends SoundController {
    constructor() {
        super(...arguments);
        this.random = new SeededRandom();
    }
    addEventListeners() {
        super.removeEventListeners();
        this.registerGame(FeaturePurpleFishEvents.FEATURE_START, this.playMusic);
        this.registerGame(GameHungryHenrySoundEvents.BOX_REVEAL, this.handleBoxReveal);
        this.registerGame(GameHungryHenrySoundEvents.BOX_SELECTED, this.handleBoxSelected);
        this.registerGame(GameHungryHenrySoundEvents.BOX1_IN, this.handleBox1In);
        this.registerGame(GameHungryHenrySoundEvents.BOX2_IN, this.handleBox2In);
        this.registerGame(GameHungryHenrySoundEvents.BOX3_IN, this.handleBox3In);
        this.registerGame(GameHungryHenrySoundEvents.BOX_OUT, this.handleBoxOut);
        this.registerGame(GameHungryHenrySoundEvents.SLAM, this.handleSlam);
        this.registerGame(GameHungryHenrySoundEvents.BURP, this.handleBurp);
        this.registerGame(GameHungryHenrySoundEvents.FURBALL, this.handleFurball);
        this.registerGame(GameHungryHenrySoundEvents.COMBINE, this.handleCombine);
        this.registerGame(GameHungryHenrySoundEvents.MULTIPLY, this.handleMultiply);
        this.registerGame(GameHungryHenrySoundEvents.TWEEN_UP, this.handleTweenUp);
        this.registerGame(MainTransitionEvents.BLACKOUT_MID_POINT, this.stopMusic);
    }
    playMusic() {
        this.playSound(this.getSoundPropertiesFromId("HUNGRY_MUSIC"));
    }
    stopMusic() {
        this.stopSound(this.getSoundPropertiesFromId("HUNGRY_MUSIC"));
    }
    handleBoxReveal() {
        this.playSound(this.getSoundPropertiesFromId("BOX_REVEAL"));
    }
    handleBoxSelected() {
        this.playSound(this.getSoundPropertiesFromId("BOX_SELECTED"));
    }
    handleBox1In() {
        this.playSound(this.getSoundPropertiesFromId("BOX1_IN"));
    }
    handleBox2In() {
        this.playSound(this.getSoundPropertiesFromId("BOX2_IN"));
    }
    handleBox3In() {
        this.playSound(this.getSoundPropertiesFromId("BOX3_IN"));
    }
    handleBoxOut() {
        this.playSound(this.getSoundPropertiesFromId("BOX_OUT"));
    }
    handleSlam() {
        this.playSound(this.getSoundPropertiesFromId("HUNGRY_SLAM"));
    }
    handleBurp() {
        const burp = this.playSound(this.getSoundPropertiesFromId("HUNGRY_BURP"));
        burp.howl.rate(0.8);
    }
    handleFurball() {
        const furball = this.playSound(this.getSoundPropertiesFromId("HUNGRY_FURBALL"));
        const rate = Math.random() * 0.5 + 0.7;
        console.log("Rate: ", rate);
        furball.howl.rate(rate);
    }
    handleCombine() {
        this.playSound(this.getSoundPropertiesFromId("HUNGRY_COMBINE"));
    }
    handleMultiply() {
        this.playSound(this.getSoundPropertiesFromId("HUNGRY_MULTIPLY"));
    }
    handleTweenUp() {
        this.playSound(this.getSoundPropertiesFromId("HUNGRY_TWEEN_UP"));
    }
}
//# sourceMappingURL=GameSoundHungryHenryController.js.map